import Main from './Main'
import Lista from './components/Policial'
import Novo from './components/NovoPolicial'

export default [
  {
    path: 'policial',
    name: 'config.policial',
    component: Main,
    redirect: { name: 'policiacivil.policia.policial.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.policia.policial.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.policia.policial.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.policia.policial.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/policiais/policial/routes.js